export const menuName = "备份管理";
export const menuList = [
  {
    key: "1",
    title: "概览",
    path: "/dashboard/devops/backup/overview",
    src: require("@/assets/svg/icon/overview.svg"),
    checkedSrc: require("@/assets/svg/icon/overview-checked.svg")
  },
  {
    key: "2",
    title: "备份计划",
    path: "/dashboard/devops/backup/plan",
    src: require("@/assets/svg/icon/plan.svg"),
    checkedSrc: require("@/assets/svg/icon/plan-checked.svg")
  },
  {
    key: "3",
    title: "备份记录",
    path: "/dashboard/devops/backup/record",
    src: require("@/assets/svg/icon/record.svg"),
    checkedSrc: require("@/assets/svg/icon/record-checked.svg")
  }
];

export const PLAN_TABLE_COLUMNS = [
  {
    title: "序号",
    dataIndex: "index",
    key: "index",
    width: 84
  },
  {
    title: "策略名字",
    dataIndex: "name",
    key: "name"
  },
  {
    title: "备份周期",
    dataIndex: "cycle",
    key: "cycle"
  },
  {
    title: "开始备份时间",
    dataIndex: "startTime",
    key: "startTime"
  },

  {
    title: "当前状态",
    dataIndex: "status",
    key: "status",
    ellipsis: true
  },
  {
    title: "操作",
    dataIndex: "action",
    key: "action"
  }
];

export const RECORD_TABLE_COLUMNS = [
  {
    title: "序号",
    dataIndex: "index",
    key: "index",
    width: 84
  },
  {
    title: "备份名称",
    dataIndex: "name",
    key: "name"
  },

  {
    title: "备份开始时间",
    dataIndex: "startTime",
    key: "startTime",
    ellipsis: true
  },
  {
    title: "备份结束时间",
    dataIndex: "endTime",
    key: "endTime",
    ellipsis: true
  },
  {
    title: "备份类型",
    dataIndex: "type",
    key: "type"
  },
  {
    title: "状态",
    dataIndex: "status",
    key: "status"
  },
  {
    title: "大小",
    dataIndex: "size",
    key: "size"
  },
  {
    title: "操作",
    dataIndex: "action",
    key: "action"
  }
];
